export const CHATBOT_CUSTOM_CODE_VIEW_STATE = "CHATBOT_CUSTOM_CODE_VIEW_STATE";

export function toggleChatbotCustomCodeViewState(value?: boolean): IChatbotCustomCodeViewStateType {
    return { type: CHATBOT_CUSTOM_CODE_VIEW_STATE, isVisible: value }
}

interface IChatbotCustomCodeViewStateType { type:string, isVisible: boolean | undefined}